/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class SmsBlacklistService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List this organization's own SMS opt-in/opt-out records.
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationSmsBlacklist({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: Array<{
            number?: string
            name?: string
            consent?: string | null
            updated_on?: string | null
        }>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/sms-blacklist',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Look up SMS opt-in status for a phone number.
     * Checks Nexmo first (global), falling back to the local Twilio-linked org records
     * (`sms_shortcode_preferences`) the same way Command Center's `nexmo_lookup` does.
     * @returns any OK
     * @throws ApiError
     */
    public getSmsBlacklistStatus({
        number
    }: {
        /**
         * Phone number, digits only (E.164 without the leading +)
         */
        number: string
    }): CancelablePromise<{
        data: Record<string, any>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sms-blacklist/{number}',
            path: {
                number: number
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Resubscribe a phone number. Always resubscribes on Nexmo; when `organization_id` is
     * given, also records the org-scoped opt-in locally (mirrors `twilio_resubscribe`).
     * Named `organization_id`, not `oid` — `ProtectRequest` middleware strips any `oid` key
     * from every request body.
     * @returns any OK
     * @throws ApiError
     */
    public resubscribeSmsNumber({
        number,
        requestBody
    }: {
        /**
         * Phone number, digits only (E.164 without the leading +)
         */
        number: string
        requestBody?: {
            /**
             * When set, also records the org-scoped opt-in locally
             */
            organization_id?: number
        }
    }): CancelablePromise<{
        data: Record<string, any>
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/sms-blacklist/{number}/resubscribe',
            path: {
                number: number
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
